import { __assign } from "tslib";
import { isPcPlatform } from '@office-start/device-detection-utility';
import { CustomPivotSettingKeyPrefix, SettingKeySeparator, } from '../models/Constants';
import { CustomFilterType } from '../models/Filters';
import { LocationFilterKey } from '../models/LocationFilters';
export function getCustomPivotSettingKey(filterType, filterKey) {
    return "".concat(CustomPivotSettingKeyPrefix).concat(SettingKeySeparator).concat(CustomFilterType[filterType].toString()).concat(SettingKeySeparator).concat(filterKey);
}
export function isCustomPivotSettingKey(settingKey) {
    return !!(settingKey &&
        settingKey.indexOf("".concat(CustomPivotSettingKeyPrefix).concat(SettingKeySeparator)) === 0);
}
export function getCustomPivotFromSettingKey(settingKey, tagMap) {
    if (!settingKey) {
        return undefined;
    }
    var keyString = settingKey.substring(CustomPivotSettingKeyPrefix.length + 1 /* Separator */);
    var separatorIndex = keyString.indexOf(SettingKeySeparator);
    if (separatorIndex < 0) {
        return undefined;
    }
    var filterType = CustomFilterType[keyString.substring(0, separatorIndex)];
    if (filterType === undefined) {
        return undefined;
    }
    var filterKey = keyString.substring(separatorIndex + 1);
    if (filterType === CustomFilterType.Location &&
        filterKey === LocationFilterKey.local &&
        !isPcPlatform()) {
        return undefined;
    }
    var customPivot = {
        customFilterKey: filterKey,
        customFilterType: filterType,
    };
    if (filterType === CustomFilterType.Tagv2) {
        var tag = 
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        tagMap && tagMap.has(filterKey) && tagMap.get(filterKey)[0];
        return __assign(__assign({}, customPivot), { customFilterTitle: (tag && tag.value) || '' });
    }
    return customPivot;
}
//# sourceMappingURL=CustomPivotUtilities.js.map